import React, { Component } from 'react';
import { Card, CardBody,
     Col, CardHeader, Badge, Row, Table, ModalHeader, Button, Modal, ModalFooter, ModalBody } from 'reactstrap';
     
import ReactDOM from 'react-dom';

import {connect} from 'react-redux'
import TextInputComponent from '../../Components/TextInputComponent';
import QueryableAreaComponent from '../../Components/QueryableAreaComponent';
import AddBlockTitle from '../../Components/AddBlockTitle';
import { Routes } from '../../Services/API';
import { GetListAttempt_ACTION, AddObjectAttempt_ACTION, AddFileAttempt_ACTION, GetListObjectAttemptPost_ACTION, GetMultipleListAttempt_ACTION } from '../../Actions/LogisticActions';
import NameComponent from '../../Components/NameComponent';
import SearchingTitleComponent from '../../Components/SearchingTitleComponent';
import AddButtonComponent from '../../Components/AddButtonComponent';
import ModalComponent from '../../Components/ModalComponent';
import { VALID_IMAGE_EXTENSIONS, GetFileExtension, CreateChuck, VALID_PDF_EXTENSIONS, VALID_VIDEO_EXTENSIONS, CheckOwnership, getRandom, getRandom_Advanced, CLICKABLE_QUESTION_PARAMETER, KEYBOARD_QUESTION_PARAMETER, MULTIPLE_CHOICE_QUESTION_PARAMETER, ENERGY_BALANCE_QUESTION_PARAMETER, getRandom_Pools, responsiveFontSize, responsiveWidth, responsiveHeight, WEBSITE_URL } from '../../Services/Utilities';
import FileInputComponent from '../../Components/FileInputComponent';
import LineComponent from '../../Components/LineComponent';
import SearchQuestionsComponent from '../../Components/SearchQuestionsComponent';
import QuestionLineViewComponent from '../../Components/QuestionLineViewComponent';
import LatexViewComponent from '../../Components/LatexViewComponent';
import ImageTreeNode from '../../Components/ImageTreeNode';
import InterpretedImageNode from '../../Components/InterpretedImageNode';
import { Input } from '@material-ui/core';
import ClickableQuestionPlayComponent from '../../Components/ClickableQuestionPlayComponent';
import IndexComponent from '../../Components/IndexComponent';
import ClickableQuestionSolutionComponent from '../../Components/ClickableQuestionSolutionComponent';
import ClickableQuestionAnswerViewComponent from '../../Components/ClickableQuestionAnswerViewComponent';

import KeyboardQuestionPlayComponent from '../../Components/KeyboardQuestionPlayComponent';
import { LS_KEYS } from '../../Actions/LSKeys';
import SafeLatexViewComponent from '../../Components/SafeLatexViewComponent';
import MultipleChoiceQuestionPlayComponent from '../../Components/MultipleChoiceQuestionPlayComponent';
import EnergyBalanceQuestionPlayComponent from '../../Components/EnergyBalanceQuestionPlayComponent';
import KeyboardQuestionAnswerViewComponent from '../../Components/KeyboardQuestionAnswerViewComponent';
import KeyboardQuestionSolutionViewComponent from '../../Components/KeyboardQuestionSolutionViewComponent';
import MultipleChoiceQuestionAnswerViewComponent from '../../Components/MultipleChoiceQuestionAnswerViewComponent';
import MultipleChoiceQuestionSolutionComponent from '../../Components/MultipleChoiceQuestionSolutionComponent';
import QRCode from 'react-qr-code';
import { Mention, MentionsInput } from 'react-mentions';

//constants
const LIST_BLOCK = +1
const VIEW_BLOCK = +2

const CLICKABLE_QUESTION = +3
const KEYBOARD_QUESTION = +4

const WIDTH_NUMBER = 22
const WIDTH_NUMBER2 = 15

const MAX_FEEDBACK_LENGTH = 500

//constants
var typingTimer;
class QuestionSeriesPlayinMap extends Component {

   constructor(props){
       super(props)

       this.state = {
        SQ:{},
        
        SelectedBlock:LIST_BLOCK,
        BaseDiv:{

        },
        QuestionsAnswers:[],
        QuestionsTime:[],
        ElementRefs:[],
        QuestionsAnswersFull: [],
        CurrentIndex:-1,
        LoadedClickableQuestions:[],
        StartPlaying: false,
        StartTime: (new Date()).getTime(),

        FeedbackComment:""
        
       }

       //
       this.SelectBlock = this.SelectBlock.bind(this)
       this.ViewBlock = this.ViewBlock.bind(this)

       this.HelpModal = this.HelpModal.bind(this)
       this.CloseModals = this.CloseModals.bind(this)
       this.FeedbackModal = this.FeedbackModal.bind(this)

       this.LoadingSeries = this.LoadingSeries.bind(this)
       this.SeriesHeader = this.SeriesHeader.bind(this)
       this.PlaySection = this.PlaySection.bind(this)
       this.FinalScores = this.FinalScores.bind(this)
       this.RegisterPDFStatistic = this.RegisterPDFStatistic.bind(this)
       this.downloadQR = this.downloadQR.bind(this)
       this.addSeriesStatistic = this.addSeriesStatistic.bind(this)


   }


  componentDidMount(){
      console.log(this.props.Code)
      this.props.GetSQ(this.props.Code)
  }

  componentWillReceiveProps(nextProps){
    console.log("SQ_Code = "+ nextProps.Code)
    if(nextProps.Code != this.state.SQ_Code){
        this.props.GetSQ(this.props.Code)
        this.setState({
            SQ_Code: nextProps.Code
        })

        return
    }
    
    if(nextProps.SQ && nextProps.SQ.Id && (this.state.SQ.Id != nextProps.SQ.Id)){
            this.setState({
                SQ: ({...nextProps.SQ}),
                ElementRefs: nextProps.SQ.Elements.map((e,i) => React.createRef()),
                RandomIds: []
            })

          if(nextProps.SQ.IsRandom){
            let ElementIds = nextProps.SQ.Elements.map((e) => e.Id)
            console.log(nextProps.SQ)
            console.log(nextProps.SQ.Elements)
            let RandomIds = getRandom_Pools(nextProps.SQ.Elements, nextProps.SQ.RandomSize)
            
            let RandomElements = RandomIds.map((Id) => {
                return nextProps.SQ.Elements.filter((e) => e.Id == Id)[0]
            })

            console.log(RandomElements)
            console.log(RandomElements.map((e)=> e.PoolNumber))

            this.setState({
                SQ: ({...nextProps.SQ, Elements:RandomElements,  ElementRefs: RandomElements.map((e,i) => React.createRef())}),
                RandomIds:[],
                IsRandom: true
            })
          }
        

          //Give Time For Div to Render
          typingTimer = setTimeout(() => {
            if(!this.state.StartPlaying){
                this.setState({
                    StartPlaying: true,
                    QuestionsAnswers:
                    !this.state.IsRandom ? 
                    nextProps.SQ                    
                    .Elements
                    .map((e) => (
                        {
                        Answered: false,
                        Score: 0,
                        Correct: false,
                        A:'',
                        Id: e.Id
                        }
                    )) : 
                    this.state.SQ                   
                    .Elements
                    .map((e) => (
                        {
                        Answered: false,
                        Score: 0,
                        Correct: false,
                        A:'',
                        Id: e.Id
                        }
                    )),
                    CurrentIndex:0,

                })}
      }, 1000);
      }
  }

  render() {      
    return (
      <div className="animated fadeIn"  ref = {'Base_Div'} >
          {this.HelpModal()}
          {this.FeedbackModal()}
        <Row>
          <Col xl={12}>
            <Card>
               <CardBody>
                    {this.ViewBlock()}
               </CardBody>
            </Card>
          </Col>
        </Row>

      </div>
    )
  }

  SelectBlock(){
    let Blocks = {
      [VIEW_BLOCK]: this.ViewBlock,

    }

    return  Blocks[this.state.SelectedBlock]()
    }


  ViewBlock(){
      console.log(this)
        return(
          <div>
              
              {(this.props.IsSQSearching || this.props.IsSQSearching == null) || this.props.GetSQError || !this.state.SQ.Id ?
               (this.LoadingSeries())
               :
               <div>
                   {this.SeriesHeader(this.props.SQ, this.state.SQ)}
                    <hr/>
                    {!this.state.StartPlaying ? 
                    <div/>
                    :
                    <div>
                        {this.state.ShowFinalScores? 
                        <div>
                            {this.FinalScores()}
                        </div>
                        :
                        <div>
                            {this.PlaySection(this.state.SQ.Elements[this.state.CurrentIndex])}
                        </div>
                        
                    }
                    </div>}
                   
                </div>}
          </div>
      )
  }


SeriesHeader(propsSQ, stateSQ){
    return(
        <div>
            <div style = {{flexDirection:'row', display:'flex', alignContent:'flex-start', alignItems:'flex-start'}}>
            <div style = {{width:'70%'}}>
            
                <h6 style = {{fontSize: responsiveFontSize(1.1), textAlign:'left'}}> 
                    {propsSQ.Code}
                </h6>
            {this.state.StartPlaying && !this.state.ShowFinalScores ?
             <div style = {{width:'50%', flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}>
                 <div className="border" 
                 
                 style={{borderRadius: responsiveFontSize(0.1), marginTop: responsiveHeight(0.5),
                     width: responsiveWidth(5), marginRight: responsiveWidth(1),
                    flexDirection:'column', alignContent:'center', alignItems:'center', display:'flex'

                 }}>
                 <h6 style = {{fontSize: responsiveFontSize(1.0), margin: responsiveFontSize(0.25)}}>
                        <strong className={this.state.QuestionsAnswers[this.state.CurrentIndex].Answered ? "text-primary" : 'text-muted'}>
                            {(this.state.CurrentIndex+1)}</strong>/{this.state.SQ.Elements.length}
                    </h6>
                 </div>
                
                {this.state.QuestionsAnswers[this.state.CurrentIndex].Answered  && !this.state.ShowFinalScores ? 
                                <h6 style = {{fontSize: responsiveFontSize(0.9), margin: responsiveFontSize(0.25), textAlign:'left'}}> 
                                <Badge color = "primary" style = {{cursor:'pointer'}}
                                onClick = {() => {
                                    if(this.state.QuestionsAnswers.filter(a => !a.Answered).length )
                                    {
                                        this.setState({
                                            CurrentIndex: this.state.CurrentIndex + 1
                                        })

                                        return
                                    }

                                    this.setState({
                                        ShowFinalScores: true
                                    })
                                    
                                }}
                                >
                                    {this.state.QuestionsAnswers.filter(a => !a.Answered).length ? 'Next' : 'Finish'}
                                </Badge>
                            </h6>     :<div/>
                        } 
                </div>

              : <div/>}
            </div>
            <div style = {{width:'30%', flexDirection:'row-reverse', display:'flex', alignItems:'flex-start', alignContent:'flex-start'}}>
            {this.state.ShowFinalScores? 
                                <h6 style = {{fontSize: responsiveFontSize(0.9), margin: responsiveFontSize(0.25), textAlign:'left'}}> 
                                <Badge color = "success"
                                            style = {{cursor:'pointer'}}

                                            onClick = {() => {
                                            this.props.Object.setState({
                                                PlaySeries: false, 
                                                SelectedElement: undefined
                                            })

                                            let progress = this.state.QuestionsAnswers.map((a) => ({
                                                Id: a.Id,
                                                Correct: a.Correct
                                             })).filter((a) => a.Correct)


                                            let nQuestions = this.state.SQ.Elements.length

                                            let data = ({
                                                MapId: this.props.ObjectId,
                                                Answers:[{
                                                    Id: this.state.SQ.Id,
                                                    ElementId: this.props.ElementId,
                                                    Progress: progress
                                                }]
                                            })

                                       

                                            this.props.Object.props.UpdateProgress(data)
                                            this.props.Object.props.GetMap(this.props.ObjectId)

                                            this.addSeriesStatistic(progress, nQuestions)
                                        }}
                                        >
                                            Finish and go back to map 
                                        </Badge>
                                    </h6>
                                : 
                                <h6 style = {{fontSize: responsiveFontSize(0.9), margin: responsiveFontSize(0.25), textAlign:'left'}}> 
                                <Badge color = "danger"
                                        style = {{cursor:'pointer'}}

                                        onClick = {() => {
                                            this.props.Object.setState({
                                                PlaySeries: false, 
                                                SelectedElement: undefined
                                            })

                                            if(!this.state.QuestionsAnswers.filter(a => !a.Answered).length){
                                               
                                                let progress = this.state.QuestionsAnswers.map((a) => ({
                                                    Id: a.Id,
                                                    Correct: a.Correct
                                                 })).filter((a) => a.Correct)
    
    
                                                let nQuestions = this.state.SQ.Elements.length

                                                this.addSeriesStatistic(progress, nQuestions)

                                            }
                                        }}
                                    >
                                        Go back to map 
                                    </Badge>
                                </h6>
                            }
                            {this.state.StartPlaying && !this.state.ShowFinalScores && stateSQ.Elements[this.state.CurrentIndex].Question.InformationId?
                                <h6 style = {{fontSize: responsiveFontSize(0.9), margin: responsiveFontSize(0.25), textAlign:'left'}}> 
                                <Badge 
                            style={{cursor:'pointer'}}
                                className="secondary"
                                onClick = {() => {
                                        if(!stateSQ.Elements[this.state.CurrentIndex].Question.Information.Latex){
                                            window.open(stateSQ[this.state.CurrentIndex].Question.Information.PDFURL)

                                            return
                                        }

                                        this.setState({
                                            ShowModal_HelpModal: true,
                                            Help: stateSQ.Elements[this.state.CurrentIndex].Question.Information
                                        })
                                    }}>
                                            Help
                            </Badge>
                        </h6>
                : <div/>}
                {(this.props.token && 
                    this.props.Name.toUpperCase() != "Student".toUpperCase() &&
                    !this.props.roles.map(r => r.toUpperCase()).includes("STUDENT"))
                ?
                <h6 style = {{fontSize: responsiveFontSize(0.9), margin: responsiveFontSize(0.25), textAlign:'left'}}
                onClick = {() => {
                                        let q = this.state.SQ
                                        let URL = WEBSITE_URL + '/Questions/QuestionSeriesView/' + q.Code
                                        window.open(URL)
                                    }}
                                    > 
                                    <Badge color ="primary" style= {{cursor:'pointer'}}>
                                        View / Edit Series
                                    </Badge>
                                </h6>                            
                            : <div/>}
                 {(!this.state.ShowFinalScores &&
                    this.state.SQ.Elements[this.state.CurrentIndex]&&
                    this.props.token && 
                    this.props.Name.toUpperCase() != "Student".toUpperCase() &&
                    !this.props.roles.map(r => r.toUpperCase()).includes("STUDENT"))
                ?
                <h6 style = {{fontSize: responsiveFontSize(0.9), margin: responsiveFontSize(0.25), textAlign:'left'}}
                onClick = {() => {
                                        let q = this.state.SQ.Elements[this.state.CurrentIndex].Question
                                        let URL = WEBSITE_URL + '/Questions/QuestionViewEdit/' + q.Id + '/'+ q.Type
                                        window.open(URL)
                                    }}
                                    > 
                                    <Badge color ="primary" style= {{cursor:'pointer'}}>
                                        View / Edit Question
                                    </Badge>
                                </h6>                            
                            : <div/>}
            </div>
            
        </div>
        
        </div>
        
    )
}


LoadingSeries(error){
    return(
        <div >
            <div style = {{flexDirection:'row'}}>
                <h6 
                className="text-primary"
                style={{fontSize: responsiveFontSize(1.2)}}>
                   {error || "Loading ..."}
                </h6>
            </div>
            <hr/>
            <div style = {{flexDirection:'row'}}>
                <h6 
            
                style={{fontSize: responsiveFontSize(0.9), display:'inline-block', backgroundColor:'lightgray', color: 'lightgray'}}>
                   {".............................................."}
                </h6>
            </div>
            <hr/>
            <div 
            style = {{flexDirection:'row'}}>
                <h6 
               
                style={{fontSize: responsiveFontSize(0.9), marginRight: responsiveWidth(0.5), display:'inline-block', backgroundColor:'lightgray', color: 'lightgray'}}>
                   {"....."}
                </h6>

                <h6 
                
                style={{fontSize: responsiveFontSize(0.9), marginRight: responsiveWidth(0.5), display:'inline-block', backgroundColor:'lightgray', color: 'lightgray'}}>
                   {"....."}
                </h6>

                <h6 
                style={{fontSize: responsiveFontSize(0.9), marginRight: responsiveWidth(0.5), display:'inline-block', backgroundColor:'lightgray', color: 'lightgray'}}>
                   {"....."}
                </h6>

                <h6 
                style={{fontSize: responsiveFontSize(0.9), marginRight: responsiveWidth(0.5), display:'inline-block', backgroundColor:'lightgray', color: 'lightgray'}}>
                   {"....."}
                </h6>

                <h6 
                style={{fontSize: responsiveFontSize(0.9), display:'inline-block', backgroundColor:'lightgray', color: 'lightgray'}}>
                   {"....."}
                </h6>
            </div>
            
        </div>
    )
}

FinalScores(){
    return(
        <div>
{this.state.SQ.Elements.map((e,i) => (
    <div key = {i}>
        <div style = {{flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start',
     }}>
        <div style = {{width:'10%'}}>
            <h6 className="text-muted" style = {{fontSize: responsiveFontSize(0.8)}}>
                {i+1}
            </h6>
        </div>
        <div style = {{width:'30%'}}>
                       
                                    <div style = {{flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center'}}> 
                                        <h6 className="text-primary" style = {{fontSize: responsiveFontSize(0.8), textAlign:'center'}}>
                                                {e.Question.Type == MULTIPLE_CHOICE_QUESTION_PARAMETER ?"" : "Your Answer"}
                                        </h6>
                                        {e.Question.Type == CLICKABLE_QUESTION_PARAMETER ? 
                                        <ClickableQuestionAnswerViewComponent 
                                            Question = {({
                                                ...this.state.QuestionsAnswersFull[i],
                                                BackgroundImageURL: e.Question.Base_ImageURL,
                                                BackgroundImageWidth: e.Question.Base_ImageURL_Width,
                                                BackgroundImageHeight: e.Question.Base_ImageURL_Height,

                                                })}
                                            Width = {responsiveWidth(WIDTH_NUMBER)}
                                            Height = {(e.Question.Base_ImageURL_Height/e.Question.Base_ImageURL_Width) * responsiveWidth(WIDTH_NUMBER)}  
                                        />  : <div/>}

                                        {e.Question.Type ==   KEYBOARD_QUESTION_PARAMETER ? 
                                            <KeyboardQuestionAnswerViewComponent 
                                                Question = {e.Question}
                                                Answers = {this.state.QuestionsAnswersFull[i]}
                                                Width = {responsiveWidth(WIDTH_NUMBER2)}
                                            />


                                        : <div/>} 

                                        {e.Question.Type == MULTIPLE_CHOICE_QUESTION_PARAMETER ? 
                                        <MultipleChoiceQuestionAnswerViewComponent 
                                            Question = {e.Question}
                                            Answers = {this.state.QuestionsAnswersFull[i]}
                                            Width = {responsiveWidth(WIDTH_NUMBER2)} 
                                        />  : <div/>}  
                                    </div> 

                                    

                               
        </div>
        <div style = {{width:'30%'}}>
                
                    <div style = {{flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center'}}> 
                        <h6 className="text-success" style = {{fontSize: responsiveFontSize(0.8), textAlign:'center'}}>
                            {e.Question.Type == MULTIPLE_CHOICE_QUESTION_PARAMETER ?"All answers" : "Correct answer"}
                        </h6>
                        {e.Question.Type == CLICKABLE_QUESTION_PARAMETER ? <ClickableQuestionSolutionComponent 
                                        Question = {this.state.LoadedClickableQuestions.filter((q) => q.Id == e.Question.Id)[0]}
                                        Width = {responsiveWidth(WIDTH_NUMBER)}
                                        Height = {(e.Question.Base_ImageURL_Height/e.Question.Base_ImageURL_Width) * responsiveWidth(WIDTH_NUMBER)}
                                        
                                    /> : <div/>}

                        {e.Question.Type ==   KEYBOARD_QUESTION_PARAMETER ? 
                        <KeyboardQuestionSolutionViewComponent 
                                                Question = {e.Question}
                                                Answers = {this.state.LoadedClickableQuestions.filter((q) => q.Id == e.Question.Id)[0].Answers}
                                                Width = {responsiveWidth(WIDTH_NUMBER2)}
                                            />: <div/>}

                        {e.Question.Type == MULTIPLE_CHOICE_QUESTION_PARAMETER ? 
                                        <MultipleChoiceQuestionSolutionComponent 
                                            Question = {this.state.LoadedClickableQuestions.filter((q) => q.Id == e.Question.Id)[0]}
                                            Answers = {this.state.QuestionsAnswersFull[i]}
                                            Width = {responsiveWidth(WIDTH_NUMBER2)} 
                                        />  : <div/>} 
                    </div>
           
        </div>
        <div style = {{flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center', width:'10%'}}> 
            <h6 className="text-primary" style = {{fontSize: responsiveFontSize(0.8), textAlign:'center'}}>
                {"Score"}
            </h6>
            <h6 className="text-primary" style = {{fontSize: responsiveFontSize(0.8), textAlign:'center'}}>
                {this.state.QuestionsAnswers[i].Score}
            </h6>
        </div>
        {this.props.Map.ShowSolutions ? 
        <div style = {{flexDirection:'column', display:'flex', alignContent:'flex-start', alignItems:'flex-start', width:'10%'}}> 
           { e.Question.PDFURL ?
           <h6 style = {{fontSize: responsiveFontSize(0.9)}}> 
            <Badge color = {'danger'}
                style = {{cursor:'pointer'}}
                onClick = {() => {
                    window.open(e.Question.PDFURL)
                   
                    this.RegisterPDFStatistic(e.Question.Id, this.props.Player, this.state.QuestionsAnswers[i].Correct)
                    }}
                    >
                        PDF Solution
                    </Badge>
                    </h6>: <div/>}
            {e.Question.VIDEOURL ?
           <h6 style = {{fontSize: responsiveFontSize(0.9)}}> 
           <Badge color = {'primary'}
                style = {{cursor:'pointer'}}
                onClick = {() => {
                    window.open(e.Question.VIDEOURL)
                                                
                  }}
                    >
                        Video Solution
                    </Badge>
                    </h6>: <div/>}
        </div>:<div/>}
        <div style = {{flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center', width:'10%'}}> 
            <h6 
            onClick = {() => {
                this.setState({
                    ShowModal_Feedback: true,
                    FeedbackQuestion:this.state.LoadedClickableQuestions.filter((q) => q.Id == e.Question.Id)[0],
                    FeedbackQuestionImage:e.Question.Base_ImageURL,
                    FeedbackComment:"",
                    ShowFeedbackSection: true
                })

                this.props.GetFeedbackQuestion(e.Question.Id)
            }}
            className="text-center" style={{fontSize: responsiveFontSize(0.8), color:'#0059b3', cursor:'pointer'}}>Send feedback</h6>
        </div>
    </div>
    <hr/>
    </div>
    ))}
        </div>
    )
}

PlaySection(element){
    
    return(
        <div>
            {element.Question.Type == CLICKABLE_QUESTION_PARAMETER ? 
                            <ClickableQuestionPlayComponent 
                                Id = {element.QuestionId} 
                                BaseDiv = {this.refs['Base_Div']}
                                InSeries = {true}
                                Object = {this}
                                Key = {this.props.Key}
                                Map = {this.props.Map}

                            /> : <div/>}

            {element.Question.Type ==  KEYBOARD_QUESTION_PARAMETER ?
                                <KeyboardQuestionPlayComponent
                                    Id = {element.QuestionId} 
                                    InSeries = {true}
                                    Object = {this}
                                    Key = {this.props.Key}
                                    Map = {this.props.Map}

                                /> : <div/>}

            {element.Question.Type == MULTIPLE_CHOICE_QUESTION_PARAMETER ?
                                    <MultipleChoiceQuestionPlayComponent
                                        Id = {element.QuestionId} 
                                        InSeries = {true}
                                        Object = {this}
                                        Map = {this.props.Map}
                                        Key = {this.props.Key}

            
                                    />: <div/>}

            {element.Question.Type == ENERGY_BALANCE_QUESTION_PARAMETER ?
                                        <EnergyBalanceQuestionPlayComponent
                                                Id = {element.QuestionId} 
                                                InSeries = {true}
                                                Object = {this}
                                                Map = {this.props.Map}

                                            /> : 
                                            <div/>}
        </div>
    )
}


RegisterPDFStatistic(question_Id, player, correct){
                                
    let data = new FormData()

    data.append('QuestionId',question_Id)
    data.append('Player', player)
    data.append('Correct', correct)                                                

    this.props.PostPDFStatistic(data)
}

HelpModal(){
    if(!this.state.ShowModal_HelpModal){
        return
    }

    return(
        <Modal isOpen = {this.state.ShowModal_HelpModal} size = {"xl"}>
            <ModalHeader toggle = {this.CloseModals}>
                Help
            </ModalHeader>
            <ModalBody>
            <div className = "border border-secondary">
                {this.state.Help.Latex ? 
                <div style = {{margin:responsiveFontSize(0.25)}}>
                    <SafeLatexViewComponent source = {this.state.Help.Latex }/>
                </div> : <div />} 
              </div>
                {this.state.Help.PDFURL ? <br/> :<div/>}
                {this.state.Help.PDFURL ? 
                <Row style = {{width:'100%'}}>
                    <Col xs = {3}>
                    <h6 style={{fontSize: responsiveFontSize(1.0)}}>
                            <Badge color = "danger" style = {{cursor:'pointer'}} onClick = {() => {
                                window.open(this.state.Help.PDFURL)
                            }}>
                                Help document (PDF) 
                            </Badge>
                        </h6>
                    </Col>
                </Row>
                :<div/>}
                
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick = {() => {
                    this.CloseModals()
                }}>
                    Close
                </Button>
            </ModalFooter>
           

        </Modal>
    )
}

FeedbackModal(){
    if(!this.state.ShowModal_Feedback){
        return
    }

    return(
        <Modal isOpen = {this.state.ShowModal_Feedback}size = {"xl"}>
            <ModalHeader toggle = {this.CloseModals}>
                Student feedback
            </ModalHeader>
            <ModalBody>
            <div style = {{flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start'}}>
                    <img 
                    className="border"
                        style = {{height:  responsiveWidth(17), width:'100%', objectFit:'contain', margin: responsiveFontSize(0.25)}}
                        src = {this.state.FeedbackQuestionImage}
                    />

                   <div style={{width: responsiveWidth(40), marginTop:'0.25%', marginLeft: '1.5%'}}>
                   <h6
                   style = {{fontSize: responsiveFontSize(0.7)}}
                   className="text-muted"
                   >Question code</h6>
                   <h6
                   style = {{fontSize: responsiveFontSize(1), marginTop: responsiveHeight(-0.5)}}
                   className="text-primary"
                   >{this.state.FeedbackQuestion.Code}</h6>

<h6
                   style = {{fontSize: responsiveFontSize(0.7)}}
                   className="text-muted"
                   >Topic</h6>
                   <h6
                   className="text-primary"
                   style = {{fontSize: responsiveFontSize(0.8), marginTop: responsiveHeight(-0.5)}}
                   >{this.state.FeedbackQuestion.Subtopic.Topic.Name}, {this.state.FeedbackQuestion.Subtopic.Name} </h6>
                    <hr/>
                   <h6 className="text-left">
                       Provide the below string or the QR code to the instructor as a short reference to the question.
                   </h6>
                    {(this.props.IsQuestionFeedbackSearching || this.props.IsQuestionFeedbackSearching == null) || this.props.GetQuestionFeedbackError ?
                    <div/>
                    :<div style = {{width:'100%', flexDirection:'column',display:'flex', alignItems:'flex-start', alignContent:'flex-start'}}>
                      
                    <div
                        onClick = {() => this.downloadQR()}
                        style = {{flexDirection:'column',display:'flex', alignContent:'center', alignItems:'center', cursor:'pointer'}}>
                        <QRCode
                        id="qr_code_question_student_feedback"
                        className="border"
                        size={256}
                        style={{ height: "auto", width: responsiveWidth(6)}}
                        value={this.props.QuestionFeedback}
                        viewBox={`0 0 256 256`}
                        />
                        <h6 className="text-muted" style = {{fontSize: responsiveFontSize(0.6), margin: responsiveFontSize(0.25)}}>
                            Click to download
                        </h6>
                    </div>
                      <div
                        style={{cursor:'pointer', width:'100%', marginTop: responsiveHeight(0.5)}}
                        onClick={() => {
                            if(window.isSecureContext){
                                console.log(this.props.QuestionFeedback)
                                navigator.clipboard.writeText(this.props.QuestionFeedback)
                            }
                            else{
                                console.log("Not secure")

                            }
                            
                          }}
                      >
                      <input 
                      style={{cursor:'pointer', width:'100%'}}
                      type="text"
                      value={this.props.QuestionFeedback}
                      disabled
                      />
                      </div>
                      <div></div>
                     
                </div>}
                   </div>
                  
                
                
            </div>
            <hr/>
            {this.state.ShowFeedbackSection ? 
            <div style = {{width:'100%', marginRight:'1%'}}>
                            <MentionsInput

                            value={this.state.FeedbackComment}
                            onChange={(e) => {
                                if(e.target.value.length > MAX_FEEDBACK_LENGTH){
                                    return
                                }

                                this.setState({
                                    FeedbackComment: e.target.value
                            })
                            }}
                                    placeholder ="Add feedback"
                                    style = {{
                                        control: {
                                          backgroundColor: 'rgb(235, 235, 235)',
                                          fontSize: responsiveFontSize(0.7),
                                          // fontWeight: 'normal',
                                        },
                                        '&multiLine': {
                                          control: {
                                            fontFamily: 'monospace',
                                            minHeight: 63,
                                          },
                                          highlighter: {
                                            padding: 9,
                                            border: '1px solid transparent',
                                          },
                                          input: {
                                            padding: 9,
                                            border: '1px solid silver',
                                          },
                                        },
                                        '&singleLine': {
                                          display: 'inline-block',
                                          width: 180,
                                          highlighter: {
                                            padding: 1,
                                            border: '2px inset transparent',
                                          },
                                          input: {
                                            padding: 1,
                                            border: '2px inset',
                                          },
                                        },
                                        suggestions: {
                                          list: {
                                            backgroundColor: 'white',
                                            border: '1px solid rgba(0,0,0,0.15)',
                                            fontSize: 16,
                                          },
                                          item: {
                                            padding: '5px 15px',
                                            borderBottom: '1px solid rgba(0,0,0,0.15)',
                                            '&focused': {
                                              backgroundColor: '#cee4e5',
                                            },
                                          },
                                        },
                                      }}
                                    >
                                <Mention
                                    data={([])} 
                                    style = {{backgroundColor: "#cee4e5"}}
                                    />
                            
                        </MentionsInput>  
                        <div style = {{flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start'}}>
                            <div style = {{width:'92%'}}>

                                <h6
                                    className="text-muted"
                                    style = {{fontSize: responsiveFontSize(0.7), textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}}>
                                        Writing as <strong>{this.props.Player}</strong> 
                                        
                                </h6> 
                                <h6
                                    className="text-muted"
                                    style = {{
                                        marginTop: responsiveHeight(-0.5),
                                        fontSize: responsiveFontSize(0.7), textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}}>
                                    ({this.state.FeedbackComment.length}/{MAX_FEEDBACK_LENGTH}) 

                                        
                                </h6> 
                            </div>  
                            <div
                            
                            style = {{
                             cursor:'pointer', width:'8%', opacity: this.state.FeedbackComment.trim() ? '100%':'40%'}} onClick = {() => {
                                if(!this.state.FeedbackComment.trim()){
                                    alert("Add feedback please")

                                    return
                                }

                                if(this.props.IsQuestionFeedbackAdding){
                                    return
                                }

                                let data = new FormData()

                                data.append("QuestionId", this.state.FeedbackQuestion.Id)
                                data.append("Feedback", this.state.FeedbackComment.trim())
                                data.append("Player", this.props.Player)

                                this.props.AddQuestionFeedback(data, () => this.setState({ShowFeedbackSection: false}))
                               
                            }}>
                                <h6 
                                style = {{fontSize: responsiveFontSize(0.8), textAlign:'right', height:'100%', width:'100%', verticalAlign:'middle'}} className="text-primary">
                                {this.props.IsQuestionFeedbackAdding ? "Sending" : "Send ➤"}
                                </h6>   
                            </div>
                        </div>
                                
                            </div> : 
                            <div>
                               
                             <h6 
                             className="text-success"
                             style={{fontSize: responsiveFontSize(1), textAlign:'center'}}>We received your feedback! We would like to thank you for sharing your opnion with us 😊</h6>   
                            <hr/>
                            </div>}
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick = {() => {
                    this.CloseModals()
                }}>
                    Close
                </Button>
            </ModalFooter>
           

        </Modal>
    )
}

downloadQR(){
    const canvas = document.createElement("canvas");
    const svg = document.getElementById("qr_code_question_student_feedback");
    const base64doc = btoa(unescape(encodeURIComponent(svg.outerHTML)));
    const w = parseInt(svg.getAttribute('width'));
    const h = parseInt(svg.getAttribute('height'));
    const img_to_download = document.createElement('img');
    img_to_download.src = 'data:image/svg+xml;base64,' + base64doc;
    console.log(w, h);
    img_to_download.onload = function () {
      console.log('img loaded');
      canvas.setAttribute('width', w);
      canvas.setAttribute('height', h);
      const context = canvas.getContext("2d");
      context.drawImage(img_to_download,0,0,w,h);
      const dataURL = canvas.toDataURL('image/png');
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(canvas.msToBlob(), "qr_code.png");
      } else {
        const a = document.createElement('a');
        const my_evt = new MouseEvent('click');
        a.download = 'qr_code.png';
        a.href = dataURL;
        a.dispatchEvent(my_evt);
      }
      //canvas.parentNode.removeChild(canvas);
    }  
    
};

CloseModals(){
    let modal_keys = Object.keys(this.state).filter(a => a.includes("ShowModal"))
    let close_modals = {}

    for(let k of modal_keys){
        close_modals[k] = false
    }
  
    this.setState(close_modals)
}

addSeriesStatistic(progress, nQuestions){
    let stat_data = new FormData()

    stat_data.append('SeriesId', this.state.SQ.Id)

    stat_data.append('Player', this.props.Player)
    stat_data.append('MapKey', this.props.Key|| "")

    stat_data.append('MapName', this.props.Map.Title)
    stat_data.append('MapElementName', this.props.Element.Title)

    stat_data.append('SuccessRate', progress.length+"/"+nQuestions)

    stat_data.append('TotalTime',  Math.trunc(0.001 * ((new Date()).getTime() - this.state.StartTime)))

    stat_data.append('OnMobile',  false)

    this.props.PostStatistic(stat_data)
}
  
}

//
const SQ_SEARCHING_PARAMETER = 'IsSQSearching'
const SQ_DATA_PARAMETER = 'SQ'
const SQ_GET_ERROR_PARAMETER = 'SQGetError'

const QS_IS_ADDING_PARAMTER = 'IsQSAdding'

const QS_ADD_ERROR_PARAMETER = 'QSAddError'
//Constant
const QUESTIONS_SEARCHING_PARAMETER = 'IsCQuestionsSearching'

const QUESTIONS_DATA_PARAMETER = 'CQuestions'

const QUESTIONS_GET_ERROR_PARAMETER = 'CQuestionsGetError'
//
const QUESTION_SEARCHING_PARAMETER = 'IsQuestionSearching'

const QUESTION_DATA_PARAMETER = 'Question'

const QUESTION_GET_ERROR_PARAMETER = 'QuestionGetError'
//
//
const QUESTION_FEEDBACK_SEARCHING_PARAMETER = 'QUESTION_FEEDBACK_SEARCHING_PARAMETER'
const QUESTION_FEEDBACK_DATA_PARAMETER = 'QUESTION_FEEDBACK_DATA_PARAMETER'
const QUESTION_FEEDBACK_GET_ERROR_PARAMETER = 'QUESTION_FEEDBACK_GET_ERROR_PARAMETER'

//
const QUESTION_FEEDBACK_IS_ADDING_PARAMETER = 'QUESTION_FEEDBACK_IS_ADDING_PARAMETER'
const QUESTION_FEEDBACK_ERROR_ADD_PARAMETER = 'QUESTION_FEEDBACK_ERROR_ADD_PARAMETER'

//
const QUESTION_STATISTIC_IS_ADDING_PARAMETER = 'QuestionStatisticIsAdding'
const QUESTION_STATISTIC_ERROR_ADD_PARAMETER = 'QuestionStatisticAddError'
function MapStateToProps(state) {
    return {

        SQ:state.Query[SQ_DATA_PARAMETER],
        IsSQSearching: state.Query[SQ_SEARCHING_PARAMETER],
        GetSQError: state.Query[SQ_GET_ERROR_PARAMETER],
        
        IsAdding: state.Query[QS_IS_ADDING_PARAMTER],
        AddError: state.Query[QS_ADD_ERROR_PARAMETER],

        IsQuestionsSearching: state.Query[QUESTIONS_SEARCHING_PARAMETER],
        Questions: state.Query[QUESTIONS_DATA_PARAMETER],
        GetQuestionsError: state.Query[QUESTIONS_GET_ERROR_PARAMETER],

        IsQuestionSearching: state.Query[QUESTION_SEARCHING_PARAMETER],
        Question: state.Query[QUESTION_DATA_PARAMETER],
        GetQuestionError: state.Query[QUESTION_GET_ERROR_PARAMETER],

        IsQuestionFeedbackSearching: state.Query[QUESTION_FEEDBACK_SEARCHING_PARAMETER],
        QuestionFeedback: state.Query[QUESTION_FEEDBACK_DATA_PARAMETER],
        GetQuestionFeedbackError: state.Query[QUESTION_FEEDBACK_GET_ERROR_PARAMETER],

        IsQuestionFeedbackAdding: state.Query[QUESTION_FEEDBACK_IS_ADDING_PARAMETER],
        AddQuestionFeedbackError: state.Query[QUESTION_FEEDBACK_ERROR_ADD_PARAMETER],

        Name: state.Authorization.name,
        token: state.Authorization.token,
        roles: state.Authorization.roles,
        Player: state.Authorization.student_key,

    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        
        GetSQ: (Code) => {dispatch(GetListAttempt_ACTION({
            SearchParameter: SQ_SEARCHING_PARAMETER,
            DataParameter: SQ_DATA_PARAMETER,
            GetErrorParameter: SQ_GET_ERROR_PARAMETER,
            
            Path: Routes.GetSeriesByCode,
            Value: Code,
    
            [SQ_SEARCHING_PARAMETER]: true,
            
            [SQ_DATA_PARAMETER]: [],
    
            [SQ_GET_ERROR_PARAMETER]: '',
        }))},
        GetQuestion: (Id, type) => {dispatch(GetListAttempt_ACTION({
            SearchParameter: QUESTION_SEARCHING_PARAMETER,
            DataParameter: QUESTION_DATA_PARAMETER,
            GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
            Path: type == CLICKABLE_QUESTION ? Routes.GetQuestionClickable : Routes.GetQuestionKeyboard,

            Value: Id,

            [QUESTION_SEARCHING_PARAMETER]: true,
            
            [QUESTION_DATA_PARAMETER]: {},
    
            [QUESTION_GET_ERROR_PARAMETER]: ''
        }))},
        GetFeedbackQuestion: (Id) => {dispatch(GetListAttempt_ACTION({
            SearchParameter: QUESTION_FEEDBACK_SEARCHING_PARAMETER,
            DataParameter: QUESTION_FEEDBACK_DATA_PARAMETER,
            GetErrorParameter: QUESTION_FEEDBACK_GET_ERROR_PARAMETER,
            Path: Routes.Feedback_ReferenceQuestion,

            Value: Id,

            [QUESTION_FEEDBACK_SEARCHING_PARAMETER]: true,
            
            [QUESTION_FEEDBACK_DATA_PARAMETER]: {},
    
            [QUESTION_FEEDBACK_GET_ERROR_PARAMETER]: ''
        }))},
        PostStatistic: (Data) => {dispatch(AddFileAttempt_ACTION({
           
            AddPath: Routes.AddSeriesStatistic,
            Body: Data,
    
           
        }))},
        PostPDFStatistic: (Statistic) => {dispatch(AddFileAttempt_ACTION({
            AddParameter: QUESTION_STATISTIC_IS_ADDING_PARAMETER,
            AddErrorParameter: QUESTION_STATISTIC_ERROR_ADD_PARAMETER,

            AddPath: Routes.AddQuestionPDFStatistic,

            [QUESTION_STATISTIC_IS_ADDING_PARAMETER]: true,
            [QUESTION_STATISTIC_ERROR_ADD_PARAMETER]: '',
            Body:Statistic
        }))},
        AddQuestionFeedback: (Comment, OnSuccess) => {dispatch(AddFileAttempt_ACTION({
            AddParameter:QUESTION_FEEDBACK_IS_ADDING_PARAMETER,
            AddErrorParameter:QUESTION_FEEDBACK_ERROR_ADD_PARAMETER,
           

            AddPath: Routes.Feedback_AddStudentFeedback,
    
            [QUESTION_FEEDBACK_IS_ADDING_PARAMETER]: true,
            [QUESTION_FEEDBACK_ERROR_ADD_PARAMETER]: '',
           

            Body:Comment,

            OnSuccess: OnSuccess
        }))},
      }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(QuestionSeriesPlayinMap)

